import { useState, useEffect, useRef } from 'react';

export default function TargetAudience() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setIsVisible(true);
        });
      },
      { threshold: 0.1 }
    );
    const el = sectionRef.current;
    if (el) observer.observe(el);
    return () => { if (el) observer.unobserve(el); };
  }, []);

  const audiences = [
    {
      icon: "ri-building-2-line",
      title: "Tổ chức quy mô lớn",
      description:
        "Các tập đoàn đa quốc gia và tổng công ty cần cấu trúc quản trị số phức hợp.",
    },
    {
      icon: "ri-calendar-todo-line",
      title: "Chương trình số hóa dài hạn",
      description:
        "Doanh nghiệp cần đối tác đồng hành xuyên suốt tiến trình hiện đại hóa 5-10 năm.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Môi trường tuân thủ cao",
      description:
        "Tổ chức tài chính, y tế, năng lượng yêu cầu các tiêu chuẩn an ninh nghiêm ngặt nhất.",
    },
  ];

  return (
    <section
      ref={sectionRef}
      id="audience"
      className="py-24 px-6 md:px-20 lg:px-40 bg-white dark:bg-slate-900 border-y border-gray-100 dark:border-gray-800"
    >
      <div className="max-w-[1200px] mx-auto text-center">
        <h2
          className={`text-3xl font-bold mb-16 text-primary dark:text-white transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          Đối tượng khách hàng trọng tâm
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {audiences.map((item, index) => (
            <div
              key={index}
              className={`flex flex-col items-center gap-4 transition-all duration-1000 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${120 + index * 100}ms` }}
            >
              <i
                className={`${item.icon} text-6xl text-primary/30`}
                aria-hidden
              />
              <h5 className="text-xl font-bold text-slate-900 dark:text-white">
                {item.title}
              </h5>
              <p className="text-slate-500 dark:text-slate-400 max-w-xs">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
